import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'content-article-body',
  name: '图文结构化正文',
  icon: '构',
  group: '图文详情页',
  description: '渲染审核通过的结构化正文、正文图片、业务卡片和内嵌视频。',
  defaultProps: {
    fontSize: 17,
    lineHeight: 1.8,
    showLead: true,
    imagePreview: true,
    renderInlineVideo: true
  }
}
